export default __webpack_public_path__ + "static/Rajdhani-Medium-a22051943d07961f5a3b43aec16ad36b.woff2";